import React, { useState, useEffect, Fragment, useRef } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import UserGuideSection from './UserGuideSection';

import { generateKey } from 'Helpers/misc';
import { addQueryStringToUrl } from 'Helpers/urlService';

import XMarkIcon from 'Assets/icons/circle-xmark.svg';
import SearchIcon from 'Assets/icons/search.svg';

export default function InstructionsIndex(props) {
    const [request, setRequest] = useState(false);
    const [instructions, setInstructions] = useState([]);
    const [expandedCategories, setExpandedCategories] = useState({});
    const [search, setSearch] = useState('');

    const timeoutRef = useRef(null);

    useEffect(() => {
        fetchUserGuides();
    }, []);

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            fetchUserGuides();
        }, 300);
    }, [search]);

    const toggleExpanded = (categoryIndex) => {
        const expanded = JSON.parse(JSON.stringify(expandedCategories));
        expanded[categoryIndex].expanded = !expanded[categoryIndex].expanded;
        setExpandedCategories(expanded);
    };

    const clearSearch = () => {
        setSearch('');
    };

    const changeSearch = (e) => {
        const value = e.target.value;
        setSearch(value);
    };

    const fetchUserGuides = () => {
        const searchTerm = search != undefined ? search : '';
        let url = addQueryStringToUrl(props.fetchUrl, 'search', searchTerm);

        setRequest(true);
        axios
            .get(url)
            .then((response) => {
                setInstructions(response.data.instructions);
                let expanded = JSON.parse(JSON.stringify(expandedCategories));
                response.data.instructions.forEach((category, index) => {
                    const categoryId = category.id;
                    expanded[index] = expanded[index] || {
                        id: categoryId,
                        expanded: false,
                    };
                });
                setExpandedCategories(expanded);
            })
            .catch((e) => {
                console.log(e.response);
            })
            .finally(() => {
                setRequest(false);
            });
    };
    return (
        <div className="row tw-px-2">
            <div className="col-12 mb-3 d-flex justify-content-end">
                <div className="mr-3">
                    <div className="input-group input-group-rounded">
                        <div className="input-group-prepend">
                            <span className="input-group-text px-3">
                                <SearchIcon className="tw-w-2.5 tw-h-2.5 tw-text-charcoal-75" />
                            </span>
                        </div>
                        <input type="text" className="form-control live-filter" placeholder={$t('Search')} value={search} onChange={changeSearch} />

                        <span className={`cursor-pointer p-1`} onClick={clearSearch} style={{ visibility: search ? 'visible' : 'hidden' }}>
                            <XMarkIcon className="tw-w-3 tw-h-3" />
                        </span>
                    </div>
                </div>
            </div>
            <div className="col">
                {instructions.map((item, categoryIndex) => {
                    const showCategory = expandedCategories[categoryIndex] ? expandedCategories[categoryIndex].expanded : true;

                    return (
                        <Fragment key={categoryIndex}>
                            <UserGuideSection
                                key={generateKey()}
                                item={item}
                                toggleExpanded={() => toggleExpanded(categoryIndex)}
                                expanded={showCategory}
                                isCategory={true}
                            />
                            <div className={showCategory ? '' : 'tw-hidden'}>
                                {item.subsections?.map((subsection, index) => {
                                    return <UserGuideSection key={generateKey()} item={subsection} isCategory={false} />;
                                })}
                            </div>
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
}

if (document.getElementById('user-guide')) {
    ReactDOM.render(
        <App>
            <InstructionsIndex fetchUrl={fetchUrl} />
        </App>,
        document.getElementById('user-guide'),
    );
}
